import { MutationTree } from 'vuex'

import _get from 'lodash/get'

import { CheckInState } from './types'
import { state as initialState } from './index'
import { Condition, OfferItem } from '../../types'

export const mutations: MutationTree<CheckInState> = {
  reset(state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },
  setOfferInformation(state, payload: { offerInformation: any }) {
    state.offerInformation = payload.offerInformation
  },
  setOfferItem(state, payload: { offerItem: OfferItem }) {
    state.offerItem = payload.offerItem
    state.requestGetOfferItem = false
    state.error = null
  },
  checkedInOfferItem(state, payload: { offerItem: OfferItem }) {
    state.requestPostCheckinOfferItem = false
    state.checkedInOfferItems = [...state.checkedInOfferItems, payload.offerItem]
  },
  setError(state, payload) {
    state.requestGetCheckedInOfferItems = false
    state.requestGetOfferItem = false
    state.requestPostCheckinOfferItem = false
    state.error = payload
  },
  setRequestGetCheckedOfferItems(state, payload: boolean) {
    state.requestGetCheckedInOfferItems = payload
    state.error = null
  },
  setRequestGetOfferItem(state, payload: boolean) {
    state.requestGetOfferItem = payload
    state.error = null
  },
  setRequestPostCheckin(state, payload: boolean) {
    state.requestPostCheckinOfferItem = payload
    state.error = null
  },
  setSelectedCondition(state, payload: Condition | null) {
    state.selectedCondition = payload
    state.error = null
  },
}
